export function getFriendlyApiError(error, fallback = 'Something went wrong. Please try again.') {
  const apiMessage = error?.response?.data?.error;
  if (apiMessage && typeof apiMessage === 'string' && !looksTechnical(apiMessage)) {
    return apiMessage;
  }

  const status = error?.response?.status;

  if (status === 401 || status === 403) {
    const apiMessage = error?.response?.data?.error;
    if (apiMessage && typeof apiMessage === 'string' && !looksTechnical(apiMessage)) {
      return apiMessage;
    }
    if (status === 403) {
      return 'You do not have permission to perform this action.';
    }
    return 'Unable to load the inbox. Sign out, sign in again, and verify Clerk keys are configured correctly.';
  }

  if (status === 404 || status === 503) {
    return 'This feature is temporarily unavailable. Please try again shortly.';
  }

  return fallback;
}

function looksTechnical(message) {
  const value = message.toLowerCase();
  return (
    value.includes('mongo') ||
    value.includes('connection') ||
    value.includes('econn') ||
    value.includes('loadbalanced') ||
    value.includes('firestore') ||
    value.includes('iam authority') ||
    value.includes('datastore') ||
    value.includes('internal server') ||
    value.includes('netlify') ||
    value.includes('axios') ||
    value.includes('undefined') ||
    value.includes('exception')
  );
}
